<app-tab-navigation-header title="Company" i18n-title="@@companyDetailMainTab-company" [detail]="companyName">
	<mat-tab-group
		appQueryStringTabGroup
		[syncUrl]="enableUpdatedSysAdmin && !propertyShellActive"
		(selectedIndexChange)="onCompanyTabIndexChange($event)"
	>
		<mat-tab label="About" i18n-label="@@companyLabel" data-automation-id="about-tab">
			<ng-template matTabContent>
				<app-company-about
					[appBreadcrumbLabel]="companyAboutBreadcrumbLabel"
					[companyResponse]="initialCompanyResponse"
					(companyUpdated)="onCompanyUpdated($event)"
				></app-company-about>
			</ng-template>
		</mat-tab>

		@if (companyDetailsReady) {
			@if (showEntityTabs && enableUpdatedSysAdmin) {
				<mat-tab label="Relationships" i18n-label="@@companyRelationships" data-automation-id="relationships-tab">
					<ng-template matTabContent>
						<app-company-relationships
							[appBreadcrumbLabel]="companyRelationshipsBreadcrumbLabel"
						></app-company-relationships>
					</ng-template>
				</mat-tab>
				<mat-tab label="Users" i18n-label="@@companyUsers" data-automation-id="users-tab">
					<ng-template matTabContent>
						<app-company-users
							[companyId]="companyId"
							[company]="company"
							[canSeeWhitelistTab]="canSeeWhitelistTab"
							[allowWhitelistMutate]="allowWhitelistMutate"
							[breadcrumbLabel]="companyUserBreadcrumbLabel"
						></app-company-users>
					</ng-template>
				</mat-tab>
				<mat-tab data-automation-id="properties-tab">
					<ng-template mat-tab-label>
						<span i18n="@@companyProperties" (click)="onPropertiesTopTabClick()">Properties</span>
					</ng-template>
					<ng-template matTabContent>
						@if (!propertyShellActive) {
							<app-sub-nav title="Properties" i18n-title="@@companyProperties">
								<app-property-list-table
									[appBreadcrumbLabel]="companyPropertiesBreadcrumbLabel"
									[propertyDataRequest]="companyPropertyDataRequest"
									[canAddProperty]="canAddProperty"
									[addTargetCompanyId]="companyId"
									[companyShellCompanyId]="companyId"
								></app-property-list-table>
							</app-sub-nav>
						}
					</ng-template>
				</mat-tab>
				<mat-tab label="Devices" i18n-label="@@companyDevices" data-automation-id="devices-tab">
					<ng-template matTabContent>
						<app-company-device-tabs
							[companyId]="companyId"
							[company]="company"
							[canWrite]="allowDeviceWrites"
							[breadcrumbLabel]="companyDevicesBreadcrumbLabel"
						></app-company-device-tabs>
					</ng-template>
				</mat-tab>
				<mat-tab label="Roles" i18n-label="@@companyRoles" data-automation-id="roles-tab">
					<ng-template matTabContent>
						<app-company-roles
							[appBreadcrumbLabel]="companyRolesBreadcrumbLabel"
							[company]="company"
						></app-company-roles>
					</ng-template>
				</mat-tab>
				@if (canAccessAuditLogs) {
					<mat-tab label="Audit Log" i18n-label="@@company-detailsAuditLog" data-automation-id="audit-log-tab">
						<ng-template matTabContent>
							<app-audit-log-list
								[companyId]="companyId"
								[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
								[hiddenColumns]="hiddenAuditLogColumns"
							></app-audit-log-list>
						</ng-template>
					</mat-tab>
				}
			}

			@if (showBillingUsersOnly) {
				<mat-tab label="Users" i18n-label="@@companyUsers" data-automation-id="users-tab">
					<ng-template matTabContent>
						<app-company-users
							[companyId]="companyId"
							[company]="company"
							[canSeeWhitelistTab]="canSeeWhitelistTab"
							[allowWhitelistMutate]="allowWhitelistMutate"
							[breadcrumbLabel]="companyUserBreadcrumbLabel"
						></app-company-users>
					</ng-template>
				</mat-tab>
				<mat-tab data-automation-id="properties-tab">
					<ng-template mat-tab-label>
						<span i18n="@@companyProperties" (click)="onPropertiesTopTabClick()">Properties</span>
					</ng-template>
					<ng-template matTabContent>
						@if (!propertyShellActive) {
							<app-sub-nav title="Properties" i18n-title="@@companyProperties">
								<app-property-list-table
									[appBreadcrumbLabel]="companyPropertiesBreadcrumbLabel"
									[propertyDataRequest]="companyPropertyDataRequest"
									[canAddProperty]="false"
									[addTargetCompanyId]="companyId"
									[companyShellCompanyId]="companyId"
								></app-property-list-table>
							</app-sub-nav>
						}
					</ng-template>
				</mat-tab>
				<mat-tab label="Devices" i18n-label="@@companyDevices" data-automation-id="devices-tab">
					<ng-template matTabContent>
						<app-company-device-tabs
							[companyId]="companyId"
							[company]="company"
							[canWrite]="allowDeviceWrites"
							[breadcrumbLabel]="companyDevicesBreadcrumbLabel"
						></app-company-device-tabs>
					</ng-template>
				</mat-tab>
			}

			@if (showEntityTabs && !enableUpdatedSysAdmin) {
				<mat-tab label="Devices" i18n-label="@@companyDevices" data-automation-id="devices-tab">
					<ng-template matTabContent>
						<app-company-devices
							[appBreadcrumbLabel]="companyDevicesBreadcrumbLabel"
							[company]="company"
						></app-company-devices>
					</ng-template>
				</mat-tab>
				<mat-tab label="Properties" i18n-label="@@companyProperties" data-automation-id="properties-tab">
					<ng-template matTabContent>
						<app-company-properties
							[appBreadcrumbLabel]="companyPropertiesBreadcrumbLabel"
							[company]="company"
						></app-company-properties>
					</ng-template>
				</mat-tab>
				<mat-tab label="Relationships" i18n-label="@@companyRelationships" data-automation-id="relationships-tab">
					<ng-template matTabContent>
						<app-company-relationships
							[appBreadcrumbLabel]="companyRelationshipsBreadcrumbLabel"
						></app-company-relationships>
					</ng-template>
				</mat-tab>
				<mat-tab label="Users" i18n-label="@@companyUsers" data-automation-id="users-tab">
					<ng-template matTabContent>
						<app-company-user [appBreadcrumbLabel]="companyUserBreadcrumbLabel" [company]="company"></app-company-user>
					</ng-template>
				</mat-tab>
				<mat-tab label="Roles" i18n-label="@@companyRoles" data-automation-id="roles-tab">
					<ng-template matTabContent>
						<app-company-roles
							[appBreadcrumbLabel]="companyRolesBreadcrumbLabel"
							[company]="company"
						></app-company-roles>
					</ng-template>
				</mat-tab>
				@if (canAccessAuditLogs) {
					<mat-tab label="Audit Log" i18n-label="@@company-detailsAuditLog" data-automation-id="audit-log-tab">
						<ng-template matTabContent>
							<app-audit-log-list
								[companyId]="companyId"
								[appBreadcrumbLabel]="auditLogBreadcrumbLabel"
								[hiddenColumns]="hiddenAuditLogColumns"
							></app-audit-log-list>
						</ng-template>
					</mat-tab>
				}
			}
		}
	</mat-tab-group>

	<!-- Always mounted so the nested Single Property route activates inside the company shell. -->
	<router-outlet></router-outlet>
</app-tab-navigation-header>
